<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <span v-if="exporting"><img src="ctc-site-logo.png" /></span>
    <div class="container">
      <div class="title is-1" style="margin-bottom:50%" v-if="exporting">
        {{$parent.options.CountryName}} - {{$parent.options.PeriodName}}
      </div>
      <div class="title is-1">Terms of Participation</div>
      <p>
        The purpose of this questionnaire is to collect and compile information about compliance with the Cape Town Convention on International Interests in Mobile Equipment and its Aircraft Protocol in each contracting state thereto on behalf of the Aviation Working Group ("<b>AWG</b>").
        By proceeding to and participating in the questionnaire, you acknowledge and agree to the following:
      </p>
      <p>
        <b>Consensus responses:</b>
        A core requirement of AWG's methodology on the Index is consensus responses among all participating firms in a contracting state.
        As such, participating firms in each contracting state are requested to coordinate and work together in order to reach a consensus on the questionnaire responses.
      </p>
      <p>
        <b>Pro bono participation:</b>
        All participation in the questionnaire will be pro bono.
      </p>
      <p>
        <b>Provision of legal facts:</b>
        This questionnaire seeks pure (non-confidential) legal facts and assessments with respect to the questions contained herein to assist the AWG secretariat in determining final scoring.
        In completing the questionnaire please do not attempt to provide any numerical input into the final Index scoring.
      </p>
      <p>
        <b>Semi-annual updates:</b>
        This questionnaire will be updated at regular semi-annual intervals and AWG requests your timely and diligent participation for each such update, as well as in connection with any material interim developments in the relevant contracting state.
      </p>
      <p>
        <b>No lawyer-client relationship:</b> No lawyer-client relationship is created by virtue of your participation in the questionnaire.
      </p>
      <br />
      <b-button class="is-primary" @click="$router.push('/questionnaire/consent')" v-if="!exporting">Next</b-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    props: {
      exporting: Boolean
    },
    methods: {

    },
    created() {
      if (!this.exporting) {
        this.$store.getters.bus.$emit('load-section');
      }
    },
    mounted() {
      this.$store.getters.bus.$emit('loaded', { exporting: this.exporting });
    }
  }
</script>
